'use client'

import { useTheme } from 'next-themes'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

function Toaster({ ...props }: ToasterProps) {
    const { theme = 'system' } = useTheme()

    return (
        <Sonner
            theme={theme as ToasterProps['theme']}
            className="group toaster"
            closeButton
            toastOptions={{
                classNames: {
                    toast:
                        'group toast group-[.toaster]:bg-popover group-[.toaster]:text-popover-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
                    description: '!text-muted-foreground',
                    actionButton: '!text-primary !bg-transparent hover:!bg-primary/10',
                },
            }}
            {...props}
        />
    )
}

export { Toaster }
